import React, { useState, useMemo } from "react";
import close from "../../assets/icons/close.svg";
import { Postdata } from "../../API/GlobalApi";
import '../../assets/css/StudentShortDetails.css'
import Notifier from "../../Utils/notify";
import { useFocusTrap } from "../../Utils/TabIndexingFocus";

const denominations = [500, 200, 100, 50, 20, 10, 5, 2, 1];

export const CashReconcile = ({ isOpen, onClose, cashInHand, getTransactionStats }) => {
    const [counts, setCounts] = useState(
        denominations.reduce((acc, d) => ({ ...acc, [d]: "" }), {})
    );


    const trapRef = useFocusTrap(isOpen);

    // Calculate totals
    const { total, shortBy } = useMemo(() => {
        const total = denominations.reduce((sum, d) => {
            const qty = parseInt(counts[d]) || 0;
            return sum + d * qty;
        }, 0);
        return { total, shortBy: cashInHand - total };
    }, [counts, cashInHand]);

    const handleChange = (denom, value) => {
        if (/^\d*$/.test(value)) {
            setCounts((prev) => ({ ...prev, [denom]: value }));
        }
    };

    const handleReconcile = async () => {
        const data = denominations
            .map((d) => ({
                denomination: d,
                quantity: parseInt(counts[d]) || 0,
            }))
            .filter((item) => item.quantity > 0);

        const payload = { data };

        try {
            const res = await Postdata("finance/cash-collection-summary/", payload);
          
            if (!res.error) {
                Notifier.success(res?.message)
                getTransactionStats()
                onClose();
            }

        } catch (err) {
            console.error("Reconcile failed:", err);
            Notifier.error(err);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div
                className="modal-content cashreconcileContainer"
                style={{
                    position: 'relative',
                    width: '40%',
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto',
                    height: '92vh'
                }}
                ref={trapRef}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                >
                    <h3 style={{ margin: 0, fontWeight: "600", fontSize: "18px" }}>
                        Reconcile Cash
                    </h3>
                    <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Cash in hand */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "15px",
                    }}
                >
                    <span style={{ fontWeight: "bold" }}>Cash in hand</span>
                    <span style={{ color: "#7F56DA", fontWeight: "600" }}>
                        ₹ {cashInHand.toLocaleString()}
                    </span>
                </div>
                <hr className="mt-1 mb-3" />

                {/* Denominations */}
                <div //style={{ maxHeight: "300px", overflowY: "auto" }}
                > <p className="mb-3" style={{ fontWeight: "bold" }}>Denomination</p>
                    {denominations.map((denom) => (
                        <div
                            key={denom}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                                gap: '10px'
                            }}
                        >
                            <span style={{ width: "60px", fontWeight: "500" }}>{denom}</span>
                            <span style={{ marginRight: "5px" }}>x</span>
                            <input
                                type="text"
                                value={counts[denom]}
                                onChange={(e) => handleChange(denom, e.target.value)}
                                placeholder="No."
                                style={{
                                    flex: "1",
                                    padding: "4px 6px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    marginRight: "10px",
                                }}
                            />
                            <span style={{ minWidth: "60px", textAlign: "right" }}>
                                ₹ {(parseInt(counts[denom]) || 0) * denom}
                            </span>
                        </div>
                    ))}
                </div>

                {/* Cash short by */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "15px",
                        fontWeight: "600",
                    }}
                >
                    <span>Cash short by</span>
                    <span
                        style={{
                            color: shortBy === 0 ? "green" : shortBy > 0 ? "red" : "orange",
                        }}
                    >
                        ₹ {shortBy.toLocaleString()}
                    </span>
                </div>

                {/* Footer buttons */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "20px",
                        gap: "10px",
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            padding: "6px 14px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            background: "#f0f0f0",
                            cursor: "pointer",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleReconcile}
                        className="add-btn"
                    >
                        Reconcile
                    </button>
                </div>
            </div>
        </div>
    );
};
